// extracted by mini-css-extract-plugin
export default {"label":"booking_status_label__71xpT"};